<template>
  <el-dropdown @command="onCommand" trigger="click">
    <el-button style="margin: 0 12px" class="top-toolbar-btn">
      <el-icon><Download /></el-icon>
      {{ $t("actions.导出图片") }}
      <el-icon><ArrowDown /></el-icon>
    </el-button>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item command="exportAllImage">
          {{ $t("actions.导出全部图片") }}
        </el-dropdown-item>
        <el-dropdown-item command="exportSelectedImage">
          {{ $t("actions.导出已选图片") }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
  <el-dialog
    v-model="state.exportImgDialogVisible"
    :title="$t('text.导出图片')"
  >
    <el-progress
      :text-inside="true"
      style="margin: 10px 0 20px 0"
      :stroke-width="26"
      :percentage="percentNum"
    />

    <div class="tips-content">
      {{ $t("text.已导出") }}:
      <span class="export-img-nums">{{
        state.exportImgMakeNum - state.exportImgList.length
      }}</span>
      {{ $t("unit.张") }}
    </div>
    <div class="tips-content">
      {{
        !state.exportImgMakeZipFinish
          ? $t("messages.导出中，请稍后")
          : $t("messages.导出完毕，请点击下载")
      }}
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button
          v-if="state.exportImgMakeZipFinish"
          type="primary"
          @click="downloadZip"
        >
          {{ $t("actions.下载") }}
        </el-button>
        <el-button @click="stopMakeZip">{{ $t("actions.取消") }}</el-button>
      </div>
    </template>
  </el-dialog>
</template>
<script lang="tsx">
import type { UnwrapNestedRefs } from "vue";
import { CollectionTag, UploadFilled, Delete, Refresh, Picture, Download, Plus, ArrowDown, } from "@element-plus/icons-vue";
import { defineComponent, computed, reactive, onBeforeMount, h, onMounted, watch } from "vue";
import type { ComputedRef } from "vue";
import moment from "moment";
import { useStore, mapGetters } from "vuex";
import type { Store } from "vuex";
import type { StoreStateType } from "@user-center/store/getters";
import type { UserStateType } from "@user-center/store/modules/user";
import lodash from "lodash-es";
import { useRoute } from "vue-router";
import type { RouteLocationNormalizedLoaded } from "vue-router";
import $ from "jquery";
import {
  ElMessageBox,
  ElMessage,
  ElButton,
  ElDropdown,
  ElNotification,
} from "element-plus";
import { $t } from "@user-center/utils/i18n.ts";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import draggable from "vuedraggable";
export default defineComponent({
  name: "ExportImageBtn",
  props: {
    selectedImgList: {
      type: Array,
      default: () => [],
    },
    allImgList: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    Download,
    ArrowDown,
  },
  setup(props) {
    const state: UnwrapNestedRefs<any> = reactive({
      // 导出图片设置
      exportImgDialogVisible: false,
      exportImgList: [],
      exportImgMakeZipFinish: false,
      exportImgMakeNum: 0,
    });
    let zipObj: any = null;
    function exportAllImage() {
      exportImage(props.allImgList);
    }
    function exportSelectedImage() {
      exportImage(props.selectedImgList);
    }

    let percentNum: ComputedRef<any> = computed(() => {
      let num: any = 0;
      let numData: any =
        ((state.exportImgMakeNum - state.exportImgList.length) /
          state.exportImgMakeNum) *
        100;
      num = parseInt(numData);

      return num;
    });
    function exportImage(imgs: any) {
      zipObj = new JSZip();
      state.exportImgMakeNum = imgs.length;
      state.exportImgMakeZipFinish = false;
      state.exportImgDialogVisible = true;
      state.exportImgList = lodash.cloneDeep(imgs);
      for (let i = 0; i < state.exportImgList.length; i++) {
        let imgUrl: string = state.exportImgList[i];
        let fetchImgUrl = imgUrl.replace(/http(s)?:/g, location.protocol);
        // 将图片URL转换为base64格式

        fetch(fetchImgUrl)
          .then((response: any) => response.blob())
          .then((blob: any) => {
            const reader: any = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = function () {
              const base64data: any = reader.result;

              // 将base64数据添加到ZIP文件中
              zipObj.file(
                imgUrl.split("/").pop(),
                base64data.replace(/^data:image\/(.*);base64,/, ""),
                {
                  binary: true,
                  base64: true,
                }
              );
              lodash.remove(state.exportImgList, (url: any) => {
                return url == imgUrl;
              });
              if (state.exportImgList.length == 0) {
                state.exportImgMakeZipFinish = true;
              }
            };
          });
      }
    }
    function downloadZip() {
      zipObj.generateAsync({ type: "blob" }).then((blob: any) => {
        // 使用FileSaver将ZIP文件下载到本地
        saveAs(blob, "images.zip");
      });
    }
    function stopMakeZip() {
      state.exportImgDialogVisible = false;
      state.exportImgMakeZipFinish = false;
      state.exportImgList = [];
      state.exportImgMakeNum = 0;
    }
    function onCommand(type: string) {
      debugger;
      if (type == "exportAllImage") {
        exportAllImage();
      } else if (type == "exportSelectedImage") {
        exportSelectedImage();
      }
    }
    return {
      state,
      percentNum,
      downloadZip,
      exportAllImage,
      exportSelectedImage,
      stopMakeZip,
      onCommand,
    };
  },
});
</script>
<style lang="scss" scoped>
.export-img-nums {
  color: red;
  font-size: 20px;
}
</style>
